/**
 * 官网美容项目（匿名接口）
 */
export function fetchPublicTreatments() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/treatments/public/list', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return Array.isArray(body.data) ? body.data : []
    })
}

/**
 * @param {string|number} id
 * @returns {Promise<Object>}
 */
export function fetchPublicTreatmentDetail(id) {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/treatments/public/detail/' + encodeURIComponent(id), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return body.data || null
    })
}
